import React, { Component } from 'react';
import styled from '@emotion/styled';

const MainColumn = styled.main`
  display: block;
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : 'transparent'};
  @media (min-width: ${props => props.theme.tablet}) {
    /*
    Here is something a bit dirt...
    On large screens, we make the main column to get "up" above previous element (dark grey heading).
    This is actually done with the negative top margin property.
    */
    ${props =>
      props.isMarginTopNegative
        ? 'margin-top: -7.1875rem; height: calc(100% + 7.1875rem);'
        : null};
  }
  @media print {
    margin-top: 0;
    height: auto;
    background-color: transparent;
  }
`;

MainColumn.defaultProps = {
  role: 'main',
};

export default MainColumn;
